module.exports = __webpack_public_path__ + "b2185c1f22dd3d91140ee15771c19bab.svg";